export enum AddressTypeEnum {
    Fiscal = 1,
    Supply = 2,
    Billing = 3
}